var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    className: "_dm-svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.856 12.986L8.612.437c-.337-.583-.887-.583-1.224 0L.144 12.986c-.337.583-.062 1.06.611 1.06h14.49c.673 0 .948-.477.611-1.06zm-6.633-.47a.307.307 0 01-.306.306H7.083a.307.307 0 01-.306-.306v-1.835c0-.168.137-.305.306-.305h1.834c.169 0 .306.137.306.305v1.835zm0-5.504c0 .168-.027.44-.06.605l-.55 1.694c-.033.165-.197.453-.366.453h-.48c-.168 0-.333-.288-.367-.453l-.563-1.617a4.633 4.633 0 01-.06-.682V4.565c0-.168.137-.306.305-.306h1.835c.168 0 .306.138.306.306v2.447z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.eaedb23bb893bf07e043588e6a81d81a.svg";
export { ForwardRef as ReactComponent };